var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_50908)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EDF0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9405 6.66602L23.2292 10.034L14.9479 18.3153L11.6592 15.0265L19.9405 6.66602Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.933 11.6582L28.2217 15.0262L14.9479 28.3L11.6592 25.0113L24.933 11.6582Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95548 16.6504L13.2442 20.0184L9.95548 23.3071L6.66675 20.0184L9.95548 16.6504Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9257 16.6504L33.2144 20.0184L19.9406 33.2922L16.6519 30.0034L29.9257 16.6504Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_50908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.dbedfa90af4b86a5bc12e5f7cc3cc047.svg";
export { ForwardRef as ReactComponent };